import React from 'react';
import {
  string,
  number,
  func
} from 'prop-types';

export const DimensionArrow = ({
  posX, posY, length, size, type, scaleFn, label
}) => {
  // How thick the lines grow relative to the arrow heads
  const scaleFactor = 0.2;
  let width = size * scaleFactor;
  let height = size * scaleFactor;

  const sideSize = size * 4;
  const tipSize = sideSize + (sideSize / 2);

  if (type === 'horizontal') {
    width = length;
  } else {
    height = length;
  }

  const arrowStyles = {
    left: scaleFn(posX),
    top: scaleFn(posY),
    height: scaleFn(height),
    width: scaleFn(width),
  };

  const arrowHeadStyles = {
    left: {
      borderTopWidth: sideSize,
      borderBottomWidth: sideSize,
      borderRightWidth: tipSize,
      left: -sideSize
    },
    right: {
      borderTopWidth: sideSize,
      borderBottomWidth: sideSize,
      borderLeftWidth: tipSize,
      right: -sideSize
    },
    up: {
      borderLeftWidth: sideSize,
      borderRightWidth: sideSize,
      borderBottomWidth: tipSize,
      top: -sideSize
    },
    down: {
      borderLeftWidth: sideSize,
      borderRightWidth: sideSize,
      borderTopWidth: tipSize,
      bottom: -sideSize
    },
  };

  const className = type === 'horizontal' ? 'dimension-arrow dimension-arrow-horizontal'
    : 'dimension-arrow dimension-arrow-vertical';

  return (
    <div className={className} style={arrowStyles}>
      {type === 'horizontal' ? (
        <>
          <div className="arrow-line">
            <div className="arrow-line-part">
              <div className="arrow-left" style={arrowHeadStyles.left} />
            </div>
            <div className="arrow-measurement">
              {label || `${length}" w`}
            </div>
            <div className="arrow-line-part">
              <div className="arrow-right" style={arrowHeadStyles.right} />
            </div>
          </div>
        </>
      )
        : (
          <>
            <div className="arrow-line">
              <div className="arrow-line-part">
                <div className="arrow-up" style={arrowHeadStyles.up} />
              </div>
              <div className="arrow-measurement">
                {label || `${length}" h`}
              </div>
              <div className="arrow-line-part">
                <div className="arrow-down" style={arrowHeadStyles.down} />
              </div>
            </div>
          </>
        )}
    </div>
  );
};

DimensionArrow.propTypes = {
  posX: number,
  posY: number,
  length: number,
  size: number,
  type: string,
  scaleFn: func,
  label: string
};

DimensionArrow.defaultProps = {
  posX: undefined,
  posY: undefined,
  length: 0,
  size: 0,
  type: 'horizontal',
  scaleFn: (value) => value,
  label: ''
};
